import { rootApi } from "../../api/rootApi";

export const supportQueriesApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllsupportQueries: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/supportQueries`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    countAllsupportQueries: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/supportQueries/count`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    fetchsupportQueriesById: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/supportQueries/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    updateSupportQueriesById: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/supportQueries/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    // ── Chat Endpoints ──────────────────────────────────────────────────────
    getChatHistory: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/support-query-chat/${params.support_query_id}?limit=${params.limit || 50}&offset=${params.offset || 0}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
    sendChatMessage: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/tenant/support-query-chat/${params.support_query_id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
        body: { message: params.message },
      }),
    }),
    markMessagesRead: builder.mutation({
      query: (params) => ({
        method: "PUT",
        url: `/tenant/support-query-chat/${params.support_query_id}/read`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
    getUnreadCount: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/support-query-chat/${params.support_query_id}/unread-count`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
    getAllUnreadCounts: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/tenant/support-query-chat/unread-all`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: params.tenant_id,
        },
      }),
    }),
  }),
});

export const {
  useFetchAllsupportQueriesMutation,
  useCountAllsupportQueriesMutation,
  useFetchsupportQueriesByIdMutation,
  useUpdateSupportQueriesByIdMutation,
  useGetChatHistoryMutation,
  useSendChatMessageMutation,
  useMarkMessagesReadMutation,
  useGetUnreadCountMutation,
  useGetAllUnreadCountsMutation,
} = supportQueriesApi;
